import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    activity: [],
    triggers: [],
    stats: [],
    dcss: null,
    mcss: null,
    stru:null,
    lnks: null,
    body: null,
    curMeta: 'settings',
    curElement: null,
    curRule: null,
    ids: [],
    runTime: [],
    currentSectionIndex: null
};

const automationSlice = createSlice({
    name: "pkzac",
    initialState,
    reducers: {
        fillTriggers(state, action) {
            state.triggers = action.payload;
        },
        fillActivity(state, action) {
            state.activity = action.payload;
        },
        fuseMail(state, action) {
            state.dcss = action.payload.dcss;
            state.mcss = action.payload.mcss;
            state.stru = action.payload.stru;
            state.lnks = action.payload.lnks;
            state.body = action.payload.body;
        },        
        fuseAC(state, action) {
            const {property, value, bmux} = action.payload;

            if(undefined !== property){
                state[property] = value;
            }

            if(undefined !== bmux) {
                $(`.${bmux}`).each(function(){
                    $(this).removeClass("active");
                    if($(this).hasClass(`state-${value}`)) {
                        $(this).addClass("active");
                    }
                })
            }
        },
        addId: (state, action) => {
			state.ids.push(action.payload);
		},
        clearIds: (state) => {
            state.ids = [];
        },
        addLastRuleUpdate: (state, action) => {
            state.runTime.push(action.payload)
        },
        updateCurrentSectionIndex: (state, action) => {
            state.currentSectionIndex = action.payload
        }     
    }
})

export const { fillTriggers, fillActivity, fuseMail, fuseAC, addId, clearIds, addLastRuleUpdate, updateCurrentSectionIndex } = automationSlice.actions;
export default automationSlice.reducer;